import { PageWrapper } from 'src/components/layout/page-wrapper'
import { Outlet } from 'react-router'
import { Sidebar } from 'src/components/sidebar'
import { SidebarProvider } from 'src/stores/sidebar'
import { AsyncJobTracker } from 'src/components/layout/async-job-tracker'
import { ActiveTasksWidget } from 'src/components/layout/active-tasks-widget'

const LayoutContent = () => {
  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden font-avenir text-primary antialiased sm:flex-row">
      <Sidebar />
      <PageWrapper className="w-full flex-grow transition-all duration-200">
        <Outlet />
      </PageWrapper>
      {/* Notifications live in the side nav. Active/failed background-task
          alerts surface in the floating pill (desktop); the mobile bottom bar
          still carries its own alerts flyout. AsyncJobTracker polls jobs and
          fires completion/failure toasts. */}
      <AsyncJobTracker />
      <ActiveTasksWidget />
    </div>
  )
}

export const Layout = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  )
}
